import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from "@angular/router";
import {inject} from "@angular/core";
import {AuthService} from "./auth-service";
import {filter, map, take} from "rxjs/operators";

export const isAuthenticatedCanActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
    return inject(AuthService).isAuthenticated().pipe(
        filter(isAuthenticated=>isAuthenticated.isAuthenticated),
        take(1),
        map(isAuthenticated=>isAuthenticated.isAuthenticated));
};
